export const en = {
  'shell.nav.schedule': 'Schedule',
  'shell.nav.shiftSettings': 'Shifts & schedules',
  'employee.tab.schedule': 'Schedule',
  'enum.shiftSwapStatus.OFFERED': 'Offered',
  'enum.shiftSwapStatus.AWAITING_APPROVAL': 'Waiting for a manager',
  'enum.shiftSwapStatus.APPROVED': 'Swapped',
  'enum.shiftSwapStatus.DECLINED': 'Declined',
  'enum.shiftSwapStatus.REJECTED': 'Rejected',
  'enum.shiftSwapStatus.WITHDRAWN': 'Withdrawn',
  'enum.scheduleKind.WEEKLY': 'Weekly',
  'enum.scheduleKind.ROTATION': 'Rotation',

  'shifts.overnight': 'overnight',
  'shifts.dayOff': 'Day off',
  'shifts.onLeave': 'On leave: {type}',
  'shifts.remove': 'Remove',
  'shifts.nameEnglish': 'Name (English)',
  'shifts.nameGeorgian': 'Name (Georgian)',
  'shifts.source.swap': 'swap',
  'shifts.source.change': 'changed',

  'shifts.page.description': "Who works when. Shifts come from each person's schedule; swaps and one-off changes sit on top, and approved leave takes a shift off.",
  'shifts.page.noRecord': 'You have no employee record here',
  'shifts.page.noRecordHint': 'Shifts belong to an employee record. Ask the owner to add you under Team → Employees and link it to your login.',
  'shifts.tab.mine': 'My shifts',
  'shifts.tab.roster': 'Team roster',
  'shifts.tab.people': 'People',
  'shifts.tab.swaps': 'Swaps',
  'shifts.week.previous': 'Previous week',
  'shifts.week.next': 'Next week',
  'shifts.week.this': 'This week',
  'shifts.mine.title': 'Your week',

  'shifts.swap.title': 'Swaps',
  'shifts.swap.none': 'No swaps yet.',
  'shifts.swap.off': 'Shift swaps are switched off at this gym.',
  'shifts.swap.offer': 'Offer to a colleague',
  'shifts.swap.offerTitle': 'Offer this shift',
  'shifts.swap.offerHint': '{shift}, {date}. Only colleagues of your department who work at this branch and are free then are listed.',
  'shifts.swap.colleague': 'Colleague',
  'shifts.swap.send': 'Send the offer',
  'shifts.swap.sent': 'Offer sent',
  'shifts.swap.nobody': 'Nobody can take it',
  'shifts.swap.nobodyHint': 'Nobody in your department who works at this branch is free then.',
  'shifts.swap.offeredTo': 'Offered to {name}',
  'shifts.swap.waitingManager': '{name} accepted; waiting for a manager',
  'shifts.swap.line': '{from} → {to}',
  'shifts.swap.accept': 'Accept',
  'shifts.swap.decline': 'Decline',
  'shifts.swap.withdraw': 'Withdraw',
  'shifts.swap.accepted': 'Swap accepted',
  'shifts.swap.declined': 'Swap declined',
  'shifts.swap.withdrawn': 'Offer withdrawn',
  'shifts.swap.approved': 'Swap approved',
  'shifts.swap.rejected': 'Swap rejected',
  'shifts.swap.waiting': 'Waiting for your decision',
  'shifts.swap.nothingWaiting': 'No swap is waiting for a decision.',
  'shifts.swap.yours': 'You are part of this swap; someone else decides it.',
  'shifts.swap.recent': 'Recent swaps',

  'shifts.roster.empty': 'Nobody has a schedule here yet',
  'shifts.roster.emptyHint': 'Give people a schedule under People; their shifts then show here week by week.',
  'shifts.roster.changeDay': 'Change {name} on {date}',
  'shifts.roster.changeTitle': 'Change {name}’s day',
  'shifts.roster.changeHint': 'A change affects this day only; the schedule stays as it is.',
  'shifts.roster.fromSwap': 'from a swap',
  'shifts.roster.remove': 'Take off',
  'shifts.roster.add': 'Add a shift',
  'shifts.roster.addButton': 'Add',
  'shifts.roster.added': 'Shift added for that day',
  'shifts.roster.removed': 'Shift taken off that day',

  'shifts.people.none': 'No one to schedule',
  'shifts.people.noneHint': 'Active employees at your branches show here.',
  'shifts.people.schedule': 'Schedule',
  'shifts.people.noSchedule': 'No schedule',
  'shifts.people.open': 'Schedule',
  'shifts.people.scheduleOf': 'Schedule: {name}',

  'shifts.assign.new': 'New schedule',
  'shifts.assign.newHint': 'The schedule repeats from its first day on until another one replaces it.',
  'shifts.assign.newHintAfter': 'The current schedule started on {date}; a new one closes it the day before it starts.',
  'shifts.assign.type': 'Schedule type',
  'shifts.assign.chooseType': 'Choose a schedule type',
  'shifts.assign.from': 'First day',
  'shifts.assign.cycleStart': 'Day 1 of the rotation',
  'shifts.assign.cycleStartHint': 'The date the rotation counts from; move it to shift who works which days.',
  'shifts.assign.preview': 'The first two weeks',
  'shifts.assign.save': 'Save schedule',
  'shifts.assign.saved': 'Schedule saved',
  'shifts.assign.none': 'No schedule yet',
  'shifts.assign.noneHint': 'Give this person a schedule to put their shifts on the roster.',
  'shifts.assign.current': 'Now',
  'shifts.assign.upcoming': 'Upcoming',
  'shifts.assign.since': 'From {from}',
  'shifts.assign.between': '{from} – {to}',
  'shifts.assign.dayOne': 'day 1 {date}',
  'shifts.assign.remove': 'Remove',
  'shifts.assign.removeTitle': 'Remove the latest schedule?',
  'shifts.assign.removeHint': 'For a schedule entered by mistake. The one before it runs on again.',
  'shifts.assign.removed': 'Schedule removed',
  'shifts.assign.end': 'End the schedule',
  'shifts.assign.endHint': '{name} stops after the day you pick; nothing replaces it.',
  'shifts.assign.lastDay': 'Last day worked',
  'shifts.assign.ended': 'Schedule ended',

  'shifts.setup.description': 'The shifts the gym works, the schedules built from them, and whether staff may swap shifts.',
  'shifts.setup.readOnly': 'Shifts and schedule types are the same at every branch, so only someone who works at every branch changes them.',
  'shifts.definition.title': 'Shifts',
  'shifts.definition.hint': 'A shift ending at or before its start runs past midnight.',
  'shifts.definition.add': 'Add a shift',
  'shifts.definition.editTitle': 'Edit the shift',
  'shifts.definition.edit': 'Edit {name}',
  'shifts.definition.delete': 'Delete {name}',
  'shifts.definition.deleteTitle': 'Delete this shift?',
  'shifts.definition.inUse': 'A schedule, a roster change, a swap or a task list uses it',
  'shifts.definition.none': 'No shifts yet',
  'shifts.definition.noneHint': 'Add the shifts the gym works, like Morning 07:00–15:00 or Night 23:00–07:00.',
  'shifts.definition.placeholder': 'Morning',
  'shifts.definition.start': 'Starts',
  'shifts.definition.end': 'Ends',
  'shifts.definition.overnightHint': 'Ends the next day.',
  'shifts.definition.color': 'Colour',
  'shifts.definition.added': 'Shift added',
  'shifts.definition.saved': 'Shift saved',
  'shifts.definition.deleted': 'Shift deleted',

  'shifts.types.title': 'Schedule types',
  'shifts.types.hint': 'A weekly schedule gives each weekday a shift or a day off. A rotation repeats a run of days, such as 3 on / 3 off, from each person’s day 1.',
  'shifts.types.add': 'Add a schedule type',
  'shifts.types.editTitle': 'Edit the schedule type',
  'shifts.types.editAssigned': 'People work this schedule; new days change their roster, past days included.',
  'shifts.types.edit': 'Edit {name}',
  'shifts.types.delete': 'Delete {name}',
  'shifts.types.deleteTitle': 'Delete this schedule type?',
  'shifts.types.deleteHint': '{name} goes. A type someone has worked stays, even after they stop.',
  'shifts.types.inUse': 'People work this schedule',
  'shifts.types.none': 'No schedule types yet',
  'shifts.types.noneHint': 'Add the shifts first, then a schedule type built from them.',
  'shifts.types.people.one': '{count} person on it now or later',
  'shifts.types.people.other': '{count} people on it now or later',
  'shifts.types.placeholder': '3 on / 3 off',
  'shifts.types.kind': 'Kind',
  'shifts.types.weeklyHint': 'The same shifts every week, Monday to Sunday.',
  'shifts.types.rotationHint': 'A run of days that repeats; its length is the cycle. Fill it in one go or day by day.',
  'shifts.types.daysOn': 'Days on',
  'shifts.types.daysOff': 'Days off',
  'shifts.types.shift': 'Shift',
  'shifts.types.fill': 'Fill in',
  'shifts.types.preview': 'The cycle',
  'shifts.types.day': 'Day {n}',
  'shifts.types.addDay': 'Add a day',
  'shifts.types.removeDay': 'Remove the last day',
  'shifts.types.added': 'Schedule type added',
  'shifts.types.saved': 'Schedule type saved',
  'shifts.types.deleted': 'Schedule type deleted',

  'shifts.swaps.title': 'Swapping shifts',
  'shifts.swaps.hint': 'Staff offer a shift to a colleague of the same department at the same branch.',
  'shifts.swaps.mode.OFF': 'Off',
  'shifts.swaps.mode.APPROVAL': 'On, a manager approves',
  'shifts.swaps.mode.FREE': 'On, without approval',
  'shifts.swaps.modeHint.OFF': 'Nobody can offer a shift.',
  'shifts.swaps.modeHint.APPROVAL': 'The colleague accepts, then someone who manages shifts at that branch approves.',
  'shifts.swaps.modeHint.FREE': 'The colleague accepting is enough; the roster changes at once.',
  'shifts.swaps.departments': 'Only these departments',
  'shifts.swaps.departmentsHint': 'Leave all unticked to let every department swap.',
  'shifts.swaps.saved': 'Swap setting saved',
  'shifts.clock.title': 'Time clock',
  'shifts.clock.hint': 'How the staff clock treats clock-ins that are forgotten or late.',
  'shifts.clock.outAfter': 'Close a forgotten clock-in after (hours)',
  'shifts.clock.outAfterHint': 'A clock-in left open this long is closed at the planned end of the shift. Without a planned shift, a manager gives it an end.',
  'shifts.clock.lateAfter': 'Late after (minutes)',
  'shifts.clock.lateAfterHint': 'Clocking in this long after a shift starts counts as late.',
  'shifts.clock.saved': 'Time clock settings saved',
};

export const ka: Record<keyof typeof en, string> = {
  'shell.nav.schedule': 'განრიგი',
  'shell.nav.shiftSettings': 'ცვლები და განრიგები',
  'employee.tab.schedule': 'განრიგი',
  'enum.shiftSwapStatus.OFFERED': 'შეთავაზებულია',
  'enum.shiftSwapStatus.AWAITING_APPROVAL': 'ელოდება ხელმძღვანელს',
  'enum.shiftSwapStatus.APPROVED': 'გაცვლილია',
  'enum.shiftSwapStatus.DECLINED': 'კოლეგამ უარი თქვა',
  'enum.shiftSwapStatus.REJECTED': 'უარყოფილია',
  'enum.shiftSwapStatus.WITHDRAWN': 'გაუქმებულია',
  'enum.scheduleKind.WEEKLY': 'კვირის',
  'enum.scheduleKind.ROTATION': 'როტაცია',

  'shifts.overnight': 'მეორე დღემდე',
  'shifts.dayOff': 'დასვენების დღე',
  'shifts.onLeave': 'შვებულებაში: {type}',
  'shifts.remove': 'წაშლა',
  'shifts.nameEnglish': 'სახელი (ინგლისურად)',
  'shifts.nameGeorgian': 'სახელი (ქართულად)',
  'shifts.source.swap': 'გაცვლა',
  'shifts.source.change': 'შეცვლილი',

  'shifts.page.description': 'ვინ როდის მუშაობს. ცვლები თითოეულის განრიგიდან მოდის; გაცვლები და ერთჯერადი ცვლილებები მის თავზე ემატება, დამტკიცებული შვებულება კი ცვლას აუქმებს.',
  'shifts.page.noRecord': 'აქ თანამშრომლის ჩანაწერი არ გაქვთ',
  'shifts.page.noRecordHint': 'ცვლები თანამშრომლის ჩანაწერზეა მიბმული. სთხოვეთ მფლობელს, დაგამატოთ გუნდში (გუნდი → თანამშრომლები) და ჩანაწერი თქვენს ანგარიშს დაუკავშიროს.',
  'shifts.tab.mine': 'ჩემი ცვლები',
  'shifts.tab.roster': 'გუნდის გრაფიკი',
  'shifts.tab.people': 'თანამშრომლები',
  'shifts.tab.swaps': 'გაცვლები',
  'shifts.week.previous': 'წინა კვირა',
  'shifts.week.next': 'შემდეგი კვირა',
  'shifts.week.this': 'ეს კვირა',
  'shifts.mine.title': 'თქვენი კვირა',

  'shifts.swap.title': 'გაცვლები',
  'shifts.swap.none': 'გაცვლები ჯერ არ არის.',
  'shifts.swap.off': 'ამ დარბაზში ცვლების გაცვლა გამორთულია.',
  'shifts.swap.offer': 'კოლეგისთვის შეთავაზება',
  'shifts.swap.offerTitle': 'ამ ცვლის შეთავაზება',
  'shifts.swap.offerHint': '{shift}, {date}. სიაში მხოლოდ თქვენი განყოფილების ის კოლეგები არიან, ვინც ამ ფილიალში მუშაობს და ამ დროს თავისუფალია.',
  'shifts.swap.colleague': 'კოლეგა',
  'shifts.swap.send': 'შეთავაზების გაგზავნა',
  'shifts.swap.sent': 'შეთავაზება გაიგზავნა',
  'shifts.swap.nobody': 'ამ ცვლის აღება არავის შეუძლია',
  'shifts.swap.nobodyHint': 'თქვენი განყოფილებიდან ამ ფილიალში ამ დროს თავისუფალი არავინაა.',
  'shifts.swap.offeredTo': 'შეთავაზებულია: {name}',
  'shifts.swap.waitingManager': '{name} დათანხმდა; ელოდება ხელმძღვანელს',
  'shifts.swap.line': '{from} → {to}',
  'shifts.swap.accept': 'დათანხმება',
  'shifts.swap.decline': 'უარის თქმა',
  'shifts.swap.withdraw': 'გაუქმება',
  'shifts.swap.accepted': 'გაცვლაზე დათანხმდით',
  'shifts.swap.declined': 'გაცვლაზე უარი თქვით',
  'shifts.swap.withdrawn': 'შეთავაზება გაუქმდა',
  'shifts.swap.approved': 'გაცვლა დამტკიცდა',
  'shifts.swap.rejected': 'გაცვლა უარყოფილია',
  'shifts.swap.waiting': 'ელოდება თქვენს გადაწყვეტილებას',
  'shifts.swap.nothingWaiting': 'გადასაწყვეტი გაცვლა არ არის.',
  'shifts.swap.yours': 'ამ გაცვლის მონაწილე ხართ; მასზე სხვა იღებს გადაწყვეტილებას.',
  'shifts.swap.recent': 'ბოლო გაცვლები',

  'shifts.roster.empty': 'აქ ჯერ არავის აქვს განრიგი',
  'shifts.roster.emptyHint': 'მიანიჭეთ განრიგები „თანამშრომლების“ ჩანართში; მათი ცვლები აქ კვირების მიხედვით გამოჩნდება.',
  'shifts.roster.changeDay': '{name}: {date} დღის შეცვლა',
  'shifts.roster.changeTitle': 'დღის შეცვლა: {name}',
  'shifts.roster.changeHint': 'ცვლილება მხოლოდ ამ დღეს ეხება; განრიგი უცვლელი რჩება.',
  'shifts.roster.fromSwap': 'გაცვლიდან',
  'shifts.roster.remove': 'მოხსნა',
  'shifts.roster.add': 'ცვლის დამატება',
  'shifts.roster.addButton': 'დამატება',
  'shifts.roster.added': 'ამ დღეს ცვლა დაემატა',
  'shifts.roster.removed': 'ამ დღეს ცვლა მოიხსნა',

  'shifts.people.none': 'განრიგის მისანიჭებელი არავინაა',
  'shifts.people.noneHint': 'აქ თქვენი ფილიალების აქტიური თანამშრომლები ჩანს.',
  'shifts.people.schedule': 'განრიგი',
  'shifts.people.noSchedule': 'განრიგი არ აქვს',
  'shifts.people.open': 'განრიგი',
  'shifts.people.scheduleOf': 'განრიგი: {name}',

  'shifts.assign.new': 'ახალი განრიგი',
  'shifts.assign.newHint': 'განრიგი პირველი დღიდან მეორდება, სანამ მას სხვა არ ჩაანაცვლებს.',
  'shifts.assign.newHintAfter': 'მიმდინარე განრიგი დაიწყო {date}; ახალი მას თავისი დაწყების წინა დღეს დაასრულებს.',
  'shifts.assign.type': 'განრიგის ტიპი',
  'shifts.assign.chooseType': 'აირჩიეთ განრიგის ტიპი',
  'shifts.assign.from': 'პირველი დღე',
  'shifts.assign.cycleStart': 'როტაციის 1-ლი დღე',
  'shifts.assign.cycleStartHint': 'თარიღი, საიდანაც როტაცია ითვლება; გადაწიეთ, რომ შეცვალოთ, ვინ რომელ დღეებში მუშაობს.',
  'shifts.assign.preview': 'პირველი ორი კვირა',
  'shifts.assign.save': 'განრიგის შენახვა',
  'shifts.assign.saved': 'განრიგი შენახულია',
  'shifts.assign.none': 'განრიგი ჯერ არ აქვს',
  'shifts.assign.noneHint': 'მიანიჭეთ განრიგი, რომ ცვლები გრაფიკში გამოჩნდეს.',
  'shifts.assign.current': 'მიმდინარე',
  'shifts.assign.upcoming': 'მომავალი',
  'shifts.assign.since': 'დაწყება: {from}',
  'shifts.assign.between': '{from} – {to}',
  'shifts.assign.dayOne': '1-ლი დღე: {date}',
  'shifts.assign.remove': 'წაშლა',
  'shifts.assign.removeTitle': 'წაიშალოს ბოლო განრიგი?',
  'shifts.assign.removeHint': 'შეცდომით შეყვანილი განრიგისთვის. წინა განრიგი ისევ გაგრძელდება.',
  'shifts.assign.removed': 'განრიგი წაიშალა',
  'shifts.assign.end': 'განრიგის დასრულება',
  'shifts.assign.endHint': '„{name}“ არჩეული დღის შემდეგ წყდება; მას არაფერი ანაცვლებს.',
  'shifts.assign.lastDay': 'ბოლო სამუშაო დღე',
  'shifts.assign.ended': 'განრიგი დასრულდა',

  'shifts.setup.description': 'დარბაზის ცვლები, მათგან აწყობილი განრიგები და შეუძლიათ თუ არა თანამშრომლებს ცვლების გაცვლა.',
  'shifts.setup.readOnly': 'ცვლები და განრიგის ტიპები ყველა ფილიალისთვის ერთია, ამიტომ მათ მხოლოდ ის ცვლის, ვინც ყველა ფილიალში მუშაობს.',
  'shifts.definition.title': 'ცვლები',
  'shifts.definition.hint': 'თუ ცვლა დაწყების დროს ან უფრო ადრე მთავრდება, ის შუაღამის შემდეგ გრძელდება.',
  'shifts.definition.add': 'ცვლის დამატება',
  'shifts.definition.editTitle': 'ცვლის რედაქტირება',
  'shifts.definition.edit': 'რედაქტირება: {name}',
  'shifts.definition.delete': 'წაშლა: {name}',
  'shifts.definition.deleteTitle': 'წაიშალოს ეს ცვლა?',
  'shifts.definition.inUse': 'მას იყენებს განრიგი, გრაფიკის ცვლილება, გაცვლა ან დავალებების სია',
  'shifts.definition.none': 'ცვლები ჯერ არ არის',
  'shifts.definition.noneHint': 'დაამატეთ დარბაზის ცვლები, მაგალითად: დილა 07:00–15:00 ან ღამე 23:00–07:00.',
  'shifts.definition.placeholder': 'დილა',
  'shifts.definition.start': 'დაწყება',
  'shifts.definition.end': 'დასრულება',
  'shifts.definition.overnightHint': 'მთავრდება მეორე დღეს.',
  'shifts.definition.color': 'ფერი',
  'shifts.definition.added': 'ცვლა დაემატა',
  'shifts.definition.saved': 'ცვლა შენახულია',
  'shifts.definition.deleted': 'ცვლა წაიშალა',

  'shifts.types.title': 'განრიგის ტიპები',
  'shifts.types.hint': 'კვირის განრიგი კვირის ყოველ დღეს ცვლას ან დასვენებას ანიჭებს. როტაცია დღეების მონაკვეთს იმეორებს, მაგალითად 3 სამუშაო / 3 დასვენება, თითოეულის 1-ლი დღიდან.',
  'shifts.types.add': 'განრიგის ტიპის დამატება',
  'shifts.types.editTitle': 'განრიგის ტიპის რედაქტირება',
  'shifts.types.editAssigned': 'ამ განრიგით ხალხი მუშაობს; ახალი დღეები მათ გრაფიკს შეცვლის, გასული დღეების ჩათვლით.',
  'shifts.types.edit': 'რედაქტირება: {name}',
  'shifts.types.delete': 'წაშლა: {name}',
  'shifts.types.deleteTitle': 'წაიშალოს ეს განრიგის ტიპი?',
  'shifts.types.deleteHint': '„{name}“ წაიშლება. ტიპი, რომლითაც ვინმეს უმუშავია, რჩება, მაშინაც კი, როცა ის აღარ მუშაობს.',
  'shifts.types.inUse': 'ამ განრიგით ხალხი მუშაობს',
  'shifts.types.none': 'განრიგის ტიპები ჯერ არ არის',
  'shifts.types.noneHint': 'ჯერ დაამატეთ ცვლები, შემდეგ კი მათგან აწყობილი განრიგის ტიპი.',
  'shifts.types.people.one': 'ახლა ან მომავალში: {count} თანამშრომელი',
  'shifts.types.people.other': 'ახლა ან მომავალში: {count} თანამშრომელი',
  'shifts.types.placeholder': '3 სამუშაო / 3 დასვენება',
  'shifts.types.kind': 'სახეობა',
  'shifts.types.weeklyHint': 'ყოველ კვირას ერთი და იგივე ცვლები, ორშაბათიდან კვირამდე.',
  'shifts.types.rotationHint': 'განმეორებადი დღეების მონაკვეთი; მისი სიგრძე ციკლია. შეავსეთ ერთბაშად ან დღე-დღე.',
  'shifts.types.daysOn': 'სამუშაო დღე',
  'shifts.types.daysOff': 'დასვენების დღე',
  'shifts.types.shift': 'ცვლა',
  'shifts.types.fill': 'შევსება',
  'shifts.types.preview': 'ციკლი',
  'shifts.types.day': '{n}-ე დღე',
  'shifts.types.addDay': 'დღის დამატება',
  'shifts.types.removeDay': 'ბოლო დღის წაშლა',
  'shifts.types.added': 'განრიგის ტიპი დაემატა',
  'shifts.types.saved': 'განრიგის ტიპი შენახულია',
  'shifts.types.deleted': 'განრიგის ტიპი წაიშალა',

  'shifts.swaps.title': 'ცვლების გაცვლა',
  'shifts.swaps.hint': 'თანამშრომელი ცვლას იმავე განყოფილებისა და ფილიალის კოლეგას სთავაზობს.',
  'shifts.swaps.mode.OFF': 'გამორთულია',
  'shifts.swaps.mode.APPROVAL': 'ჩართულია, ამტკიცებს ხელმძღვანელი',
  'shifts.swaps.mode.FREE': 'ჩართულია, დამტკიცების გარეშე',
  'shifts.swaps.modeHint.OFF': 'ცვლის შეთავაზება არავის შეუძლია.',
  'shifts.swaps.modeHint.APPROVAL': 'კოლეგა თანხმდება, შემდეგ კი ამტკიცებს ის, ვინც ამ ფილიალში ცვლებს მართავს.',
  'shifts.swaps.modeHint.FREE': 'კოლეგის თანხმობა საკმარისია; გრაფიკი მაშინვე იცვლება.',
  'shifts.swaps.departments': 'მხოლოდ ეს განყოფილებები',
  'shifts.swaps.departmentsHint': 'თუ არცერთს მონიშნავთ, გაცვლა ყველა განყოფილებას შეეძლება.',
  'shifts.swaps.saved': 'გაცვლის პარამეტრი შენახულია',
  'shifts.clock.title': 'სამუშაო დროის აღრიცხვა',
  'shifts.clock.hint': 'როგორ ეპყრობა აღრიცხვის სისტემა დავიწყებულ და დაგვიანებულ მოსვლებს.',
  'shifts.clock.outAfter': 'დავიწყებული მოსვლის დახურვა (საათი)',
  'shifts.clock.outAfterHint': 'ამდენი ხნის განმავლობაში ღია მოსვლა ცვლის დაგეგმილ დასრულებაზე იხურება. დაგეგმილი ცვლის გარეშე დასასრულს ხელმძღვანელი უთითებს.',
  'shifts.clock.lateAfter': 'დაგვიანება (წუთი)',
  'shifts.clock.lateAfterHint': 'ცვლის დაწყებიდან ამდენი ხნის შემდეგ აღრიცხული მოსვლა დაგვიანებად ითვლება.',
  'shifts.clock.saved': 'სამუშაო დროის აღრიცხვის პარამეტრები შენახულია',
};
